import React from "react";
import { useNavigate } from "react-router-dom";
import PanelTemplate from "../../templates/Panel";
import Box from "../../components/Box";
import Button from "../../components/Button";

const NotFound = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <PanelTemplate id="not-found">
            <div style={{ textAlign: 'center', padding: '60px 20px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <img src={require('../../assets/images/404.webp')} alt="404" style={{ width: '80%', maxWidth: '500px' }} />
                <h1 style={{ fontSize: '24px', margin: '50px 0 10px 0', color: '#666' }}>Recurso não encontrado</h1>
                <p style={{ fontSize: '16px', margin: '0 0 40px 0', color: '#999' }}>
                    O recurso que você está procurando não existe ou foi removido.
                </p>
            </div>
        </PanelTemplate>
    );
};

export default NotFound;

